import { useState } from "react";
import { Outlet } from "react-router-dom";

import AppDrawer from "@/components/layout/AppDrawer";
import AppHeader from "@/components/layout/AppHeader";

/**
 * 認証済み画面の共通レイアウト（ヘッダ + ドロワー + 本体）。
 *
 * ドロワーは常時開きではなくオーバーレイにする。一覧テーブルに画面幅を
 * 使い切れるようにするため（ngtg_msc と同じ）。
 */
export default function AppShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="flex h-dvh flex-col">
      <AppHeader onOpenDrawer={() => setDrawerOpen(true)} />
      <AppDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <main className="flex-1 overflow-auto bg-page">
        <Outlet />
      </main>
    </div>
  );
}
